<!-- <header class="fixed-top">fixedTopCustom -->
<header class="fixedTopCustom">
  <div class="col-lg-12 mt-3">
    <div class="container-fluid">
      <div class="row justify-content-between align-items-center pb-1">
        <div class="col-lg-3 col-md-3 col-3">
          <div class="row">
            <div class="col-lg-2"> <button id="sidebarCollapse" class="pl-2 pr-2 menuclick" type="button"
              (click)="clicktoggle()">
              <i class="fa fa-bars" [ngClass]="fullscreen ? '' : 'hide'" aria-hidden="true"></i>
              <svg [ngClass]="fullscreen ? 'hide' : ''" xmlns="http://www.w3.org/2000/svg" width="18"
                height="18" fill="currentColor" class="bi bi-x-lg i-close" viewBox="0 0 16 16">
                <path
                  d="M1.293 1.293a1 1 0 0 1 1.414 0L8 6.586l5.293-5.293a1 1 0 1 1 1.414 1.414L9.414 8l5.293 5.293a1 1 0 0 1-1.414 1.414L8 9.414l-5.293 5.293a1 1 0 0 1-1.414-1.414L6.586 8 1.293 2.707a1 1 0 0 1 0-1.414z" />
                </svg>
                <span class="sr-only"> click here</span>
              </button></div>
              <div class="col-lg-9">
                <!-- <img src="assets/images/enit.png" routerLink=""class="logo" /> -->
                <img src="assets/images/NSE_IX-logo.png" routerLink="" class="logo" />
              </div>

            </div>
          </div>

          <div class="col-lg-4 col-md-4 col-3">
            <div class="row mt-xs-1 mb-xs-1 justify-content-end">
              @if (collateralMenu?.isAccessAllowed == 'Y') {
                <div class="col-lg-4 mt-2">
                  <a class="contact" routerLink="/timing">Collateral Timing</a>
                </div>
              }
              <div class="col-lg-4 mt-2">
                <a class="contact" routerLink="/form/contact">Contact Us</a>
              </div>
              <!-- <div class="col-lg-4 mt-2 marketopen">Market Open</div> -->
              <!-- <div class="col-lg-2 mt-2">
              <i class="fa fa-bell-o fa-2x" aria-hidden="true"></i>
              <span class="badge badge-color">10</span>
            </div> -->
            <div class="col-lg-2 mt-2">
              <div class="d-flex justify-content-end">
                <div class="dropdown changepass">
                  <a href="" class="mb-0 dropdown-toggle" type="button" id="dropdownMenuButton"
                    data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                    <div class="ml-2">
                      <div class="initial">
                        {{userDetails && userDetails.loginId[0]}}
                      </div>
                    </div>
                    <span class="caret"></span>
                  </a>
                  <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
                    <div class="d-flex dropdown-item">
                      <div class="nowrap mr-2">
                        <div class="mb-0 nowrap userdropdown">
                          <p>{{userDetails && userDetails.loginId}}</p>
                        </div>
                      </div>
                    </div>
                    <!-- <a class="dropdown-item pointer" data-toggle="modal"
                    data-target="#forgotpass">Profile
                  </a> -->
                  <a class="dropdown-item pointer" (click)="profile()">Profile
                  </a>
                  <a class="dropdown-item pointer" (click)="changePassword()">Change Password
                  </a>
                  <a class="dropdown-item pointer" (click)="logout()">Logout
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
</header>
<div class="fullwrapper">
  <app-sidebar [ngClass]="fullscreen ? 'active' : ''"></app-sidebar>
  <div id="content" (click)="hideSidebar()">
    <router-outlet></router-outlet>
  </div>
</div>